<template>
    <div>
        <pop-form class="form-box" :state="show" width="620px" body-max-height="500px">
            <template slot="title">服务人员</template>
            <div class="body-box">
                <!--职位筛选-->
                <div class="category-box">
                    <div class="left-box">
                        <i class="el-icon-arrow-left" @click="rightMove"></i>
                    </div>
                    <div class="center-box">
                        <div ref="content" class="content">
                            <div class="content-item" :class="{active: form.role_id === val.role_id}" v-for="val in roleData"
                                 :key="val.role_id" @click="form.role_id = val.role_id">
                                {{val.role_name}}
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <i class="el-icon-arrow-right" @click="leftMove"></i>
                    </div>
                </div>
                <!--搜索-->
                <div class="search-box flex">
                    <i class="input_icon el-icon-search"></i>
                    <input class="flex-1 search-input" type="text" v-model="search" placeholder="工号/姓名" @input="searchChange" />
                </div>
                <!--员工列表-->
                <div class="list-data-box">
                    <div class="list-box">
                        <div class="item" v-for="(val, k) in staffListData" :key="k">
                            <div class="check-box" :class="{active: isSelected(val.id)}"
                                 @click="selected(val)">
                                <div class="staff-name">{{val.work_id}}{{val.name}}</div>
                                <el-checkbox v-model="val.is_assign" class="assign-check" v-show="isAssign(val)">
                                    点客
                                </el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template slot="foot">
                <div class="foot-box">
                    <div class="check-all-box">
                        <el-checkbox v-model="checkAll">全选</el-checkbox>
                    </div>
                    <el-button size="medium" @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                    <el-button size="medium" type="primary" @click="submit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </template>
        </pop-form>
    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "CashStaffSelectBox",
        components: {PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: true
            },
            selectedStaff: {
                type: Array,
                default: () => ([])
            },
            proType: {
                type: Number,
                default: ""
            }
        },
        data: () => ({
            transX: 0,

            roleData: [],
            form: {
                role_id: 0,
            },

            checkAll: false,
            search: "",

            activeData: [], //选择的数据
            staffListData: [
                // {
                //     id: "",
                //     name: "不选择",
                //     work_id: "",
                //     rew_id: ""
                // }
            ],
            staffOriginData: [],
        }),
        mounted: function () {

        },
        methods: {
            //初始化
            init: function () {
                this.activeData = obj.copyObject(this.selectedStaff);
                this.getRoleList();
                this.getStaffListData();
            },
            //左右移动角色
            animateMove: function (width, time) {
                let t = 0;
                let ts = 1;
                let speed = width * (ts / time);
                let contentDom = this.$refs.content;
                let maxWidth = contentDom.parentElement.offsetWidth;
                let clientWidth = contentDom.offsetWidth;

                let timer = setInterval( () => {
                    this.transX += speed;
                    if(width > 0 && this.transX >= 0) {
                        this.transX = 0;
                    }
                    if(width < 0 && maxWidth - clientWidth >= this.transX) {
                        this.transX = maxWidth <= clientWidth ? maxWidth - clientWidth : 0;
                    }

                    contentDom.style.transform = "translateX("+this.transX+"px)";
                    t += ts;
                    if( t >= time) clearInterval(timer);
                }, ts);
            },
            rightMove: function () {
                this.animateMove(100, 50);
            },
            leftMove: function () {
                this.animateMove(-100, 50);
            },

            //关闭
            close: function () {
                this.$emit("showChange", false);
            },

            //提交
            submit: function () {
                this.$emit("selected", this.activeData);
                this.close();
            },

            //搜索值改变
            searchChange: function () {
                let search = this.search;
                let listData = [];
                if(search === "") {
                    listData = this.staffOriginData;
                }else {
                    this.staffOriginData.forEach((val, key) => {
                        if (val.work_id.indexOf(search) > -1) {
                            listData.push(val);
                        } else if (val.name.indexOf(search) > -1) {
                            listData.push(val);
                        }
                    });
                }
                this.staffListData = listData;
            },

            //获取职位
            getRoleList: function () {
                obj.postData("store_role/get_role_list", {}, res => {
                    if(res.errcode === 0) {
                        let listData = [...res.data];
                        listData.unshift({
                            role_id: 0,
                            role_name: "所有"
                        });
                        this.roleData = listData;
                    }else
                        obj.message.error(res.errdesc);
                });
            },

            //获取员工列表
            getStaffListData: function () {
                let postData = {
                    role_id: this.form.role_id
                };
                obj.postData("cash/get_staff_list", postData, res => {
                    if(res.errcode === 0) {
                        this.staffListData = this.staffOriginData = res.data;
                        if(!obj.isEmpty(res.data)) {
                            res.data.forEach( val => {
                                if(this.getSelectedStaffValue(val.id, "is_assign")) val.is_assign = true;
                            });
                        }
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },

            //选择员工
            selected: function (item) {
                let isActive = false;
                if(!obj.isEmpty(this.activeData)) {
                    for (let k in this.activeData) {
                        if(this.activeData[k].id === item.id) {
                            this.activeData.splice(k, 1);
                            isActive = true;
                            break;
                        }
                    }
                }
                if(!isActive)
                    this.activeData.push(item);
            },

            //是否被选中
            isSelected: function (id) {
                return !!this.getSelectedStaffValue(id, "id");
            },
            //是否点客
            isAssign: function (item) {
                if(this.proType !== 1) return false;

                return this.isSelected(item.id);
            },
            //获取已选员工指定ID的属性
            getSelectedStaffValue: function (id, field) {
                let result = "";
                if(!obj.isEmpty(this.activeData)) {
                    for (let k in this.activeData) {
                        if(this.activeData[k].id === id) {
                            result = this.activeData[k][field];
                            break;
                        }
                    }
                }
                return result;
            }
        },
        watch: {
            show: function (val) {
                if(val) this.init();
            },
            "form.role_id": function () {
                this.getStaffListData();
            },
            checkAll: function (val) {
                if(val) {
                    this.staffListData.forEach(staff => {
                        if(!this.getSelectedStaffValue(staff.id, "id"))
                            this.activeData.push(staff);
                    });
                }else if(!obj.isEmpty(this.activeData)){
                    this.staffListData.forEach(staff => {
                        for (let k in this.activeData) {
                            if(this.activeData[k].id === staff.id)
                                this.activeData.splice(k, 1);
                        }
                    });
                }
            },
            activeData: function (val) {
                if(obj.isEmpty(val))
                    this.checkAll = false;
            },
        }
    }
</script>

<style scoped>
    .foot-box{
        padding: 0 20px 10px;
        text-align: right;
        line-height: normal;
    }
    .foot-box .check-all-box{
        float: left;
    }
    .category-box{
        margin-top: 6px;
        display: flex;
        flex-flow: row nowrap;
        line-height: 36px;
        padding: 0 10px;
    }
    .category-box>.left-box{
        width: 30px;
        text-align: center;
        cursor: pointer;
        background-color: #f6f6f6;
    }
    .category-box>.right-box{
        width: 30px;
        text-align: center;
        cursor: pointer;
        background-color: #f6f6f6;
    }
    .category-box>.center-box{
        flex: 1;
        overflow: hidden;
        background-color: #f6f6f6;
    }
    .category-box>.center-box>.content{
        /*width: 1000px;*/
        /*background-color: red;*/

        display: inline-block;
        white-space:nowrap;
        height: 36px;
        position: relative;
    }
    .content > .content-item{
        display: inline-block;
        width: 87px;
        height: 36px;
        text-align: center;
        color: #333333;
        cursor: pointer;
    }
    .content > .content-item.active, .content > .content-item:hover{
        background-color: #6cb1e1;
        color: #FFFFFF;
    }

    .search-box{
        margin: 10px 10px 0px;
        border-bottom: 1px solid #e5e5e5;
    }
    .search-box .input_icon{
        padding: 0px 10px;
        line-height: 40px;
        color: #999999;
    }
    .search-box>input{
        border: none;
    }
    .search-input::placeholder {
        color: #999999;
    }
    .list-data-box{
        height: 282px;
    }
    .list-box{
        padding: 12px 0px 12px 10px;
        margin-right: 10px;
        display: flex;
        flex-flow: row wrap;
        max-height: 258px;
        overflow: auto;
    }
    .list-box>.item{
        width: 50%;
    }
    .item .check-box{
        margin: 8px;
        padding: 0px 16px;
        line-height: 43px;
        height: 43px;
        border: 1px solid #e5e5e5;
        cursor: pointer;
    }
    .item .check-box.active, .item .check-box:hover{
        border-color: #6cb1e1;
        background-color: #f0f7fc;
    }
    .item .check-box.disabled{
        border-color: #f1f1f1;
        background-color: #f7f7f7;
    }
    .item .staff-name{
        display: inline-block;
        width: 150px;
        overflow: hidden;
        white-space:nowrap;
    }
    .item .assign-check{
        float: right;
    }
</style>
